module.exports = __webpack_public_path__ + "img/rating_5.90afd922.png";